"use client";

import React, { useEffect, useRef, useState } from 'react';
import { Moon, Truck, Clock, CircleCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NightLogistics() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const [animationState, setAnimationState] = useState<'pickup' | 'delivery'>('pickup');
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationState(prev => prev === 'pickup' ? 'delivery' : 'pickup');
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <section id="praní-bez-přerušení-vašeho-provozu" className="dark bg-background text-foreground py-20 overflow-hidden relative">
      {/* Background glow effect */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(6,182,212,0.05),transparent_70%)] pointer-events-none" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Content */}
          <div ref={sectionRef} className={`space-y-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/10 border border-secondary/20 text-secondary text-sm font-medium">
              <Moon className="w-4 h-4" />
              <span>Noční logistika</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white">
              Zatímco vaši hosté spí, <span className="text-secondary">my pracujeme.</span>
            </h2>
            
            <p className="text-lg text-muted-foreground leading-relaxed">
              Naše specializovaná noční přeprava zajišťuje, že špinavé prádlo zmizí večer a čisté se objeví ráno. 
              Garantujeme nulové narušení provozu vašeho hotelu či wellness centra.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              <div className="flex gap-4">
                <div className="mt-1 bg-secondary/10 p-2 rounded-lg h-fit">
                  <Clock className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Svoz převážně v nočních hodinách<br /></h3>
                  <p className="text-sm text-muted-foreground">
                    Přizpůsobíme se vašemu nejklidnějšímu času.
                  </p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="mt-1 bg-secondary/10 p-2 rounded-lg h-fit">
                  <Truck className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Tichá logistika</h3>
                  <p className="text-sm text-muted-foreground">
                    Diskrétní vyzvednutí a doručení bez hluku.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="mt-1 bg-secondary/10 p-2 rounded-lg h-fit">
                  <CircleCheck className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">100% Spolehlivost</h3>
                  <p className="text-sm text-muted-foreground">
                    Čisté prádlo připraveno před snídaní.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90">
                <Link to="/ContactPage">Poptat svoz prádla</Link>
              </Button>
            </div>
          </div>

          {/* Right Visualization */}
          <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            
          </div>

        </div>
      </div>

      <style>{`
        @keyframes rotateClockHand {
          from {
            transform: rotate(300deg);
          }
          to {
            transform: rotate(540deg);
          }
        }

        @keyframes deliveryRoute {
          0% {
            transform: translate(500px, 320px);
          }
          100% {
            transform: translate(100px, 320px);
          }
        }

        @keyframes pickupRoute {
          0% {
            transform: translate(100px, 320px);
          }
          100% {
            transform: translate(500px, 320px);
          }
        }

        .animate-delivery-route {
          animation: deliveryRoute 4s ease-in-out;
        }

        .animate-pickup-route {
          animation: pickupRoute 4s ease-in-out;
        }
      `}</style>
    </section>;
}